import { createReducer } from 'redux-starter-kit';
import { adminTeamMembersActions } from '../actions';
import getStdDbModelReduxMapping from './std-db-model-reducers';

export const adminTeamMembersInitialState = {};

const adminTeamMembersReducer = createReducer(
  adminTeamMembersInitialState,
  getStdDbModelReduxMapping(adminTeamMembersActions),
);

export default adminTeamMembersReducer;
